<template>
    <b-container>
        <b-row>
            <b-col
                cols="12"
                md="4"
                v-for="process in processes"
                :key="process.id"
                class="mb-2"
            >
                <b-card @click="openProcess(process)" class="folder">
                    <b-card-text>
                        <b-row align-v="center">
                            <b-col cols="auto">
                                <i
                                    class="fa fa-cog fa-3x folder-icon"
                                    aria-hidden="true"
                                ></i>
                            </b-col>
                            <b-col>
                                {{ process.name }}
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col>
                                <i class="fa fa-user text-primary" aria-hidden="true"></i> {{ !!process.leader? process.leader.name: 'Sin definir' }}
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
                <b-btn
                    v-if="userCan('set-process-leader')"
                    size="sm"
                    block
                    variant="primary"
                    @click="openLeaderWindow(process)"
                >
                    <i class="fa fa-user-circle-o" aria-hidden="true"></i> Lider
                </b-btn>
            </b-col>
        </b-row>
        <b-modal
            title="Definición de lider del proceso"
            id="process-leader-window"
            ref="process-leader-window"
            ok-title="Seleccionar"
            cancel-title="Cancelar"
            @ok.prevent="setLeader"
        >
            <b-card v-if="!!selectedProcess">
                <b-card-title>
                    {{ selectedProcess.name }}
                </b-card-title>
                <label for="leader">Lider</label>
                <b-form-select id="leader" :options="leaders" text-field="name" value-field="id" v-model="leaderId">
                    <option value="">Seleccione</option>
                </b-form-select>
            </b-card>
        </b-modal>
    </b-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data: () => ({
        processes: [],
        selectedProcess: null,
        leaderId: '',
        busy: false,
    }),
    computed: {
        ...mapGetters(['administrativeUsers']),
        leaders() {
            if(!this.administrativeUsers) return []
            return this.administrativeUsers.map(item => ({
                id: item.id,
                name: `${item.name} (${item.position.name})`
            }))
        }
    },
    methods: {
        async loadProcesses() {
            const { data } = await repo.get('quality/processes')
            this.processes = data
        },
        openProcess(process) {
            const payload = btoa(
                JSON.stringify({
                    processId: process.id,
                    processName: process.name,
                })
            )
            this.$router.push({
                name: 'documentTypes',
                query: {
                    p: payload,
                },
            })
        },
        openLeaderWindow(process) {
            this.selectedProcess = process
            this.leaderId = process.leader_id??''
            this.openModal('process-leader-window')
        },
        async setLeader() {
            try {
                this.busy = true
                const {data} = await repo.post(`quality/processes/${this.selectedProcess.id}/set-leader`, {
                    leaderId: this.leaderId
                })

                const index = this.processes.findIndex(item => item.id === this.selectedProcess.id)
                const leader = this.administrativeUsers.find(item => item.id === this.leaderId)
                this.processes[index].leader_id = this.leaderId
                this.processes[index].leader = {
                    id: leader.id,
                    name: leader.name
                }

                this.leaderId = ''
                this.selectedProcess = null
                this.closeModal('process-leader-window')
                toastr.success('El lider del proceso fue asignado satisfactoriamente')
            } catch(e) {
                toastr.error(`Ocurrió un error al seleccionar al lider del proceso (${e})`)
            } finally {
                this.busy = false
            }

        }
    },
    created() {
        this.loadProcesses()
        this.load('administrativeUsers')
    },
}
</script>
<style scoped>
.folder {
    cursor: pointer;
}
.folder-icon {
    color: #ff761c;
}
</style>
